module.exports = __webpack_public_path__ + "macbook-mqd.d19f20b194bc5abd13fe207c97f92fbe.png";